/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/credentialLists.config.json';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_MY_CREDENTIAL_LIST } from '../graphql';
import { VApplication } from '../../../application';




const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

const parse = require("url-parse");
export interface ICredentialListsMethods extends IPluginMethodMap {
  getCredentialIssuedListsProps(args: any): Promise<any>;
}

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  criteria?: any;
}

export class CredentialIssuedListsService implements IAgentPlugin {
  readonly methods: ICredentialListsMethods;

  constructor() {
    this.methods = {
      getCredentialIssuedListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    // const { id ,uuid} = useTemplateId();
    const url = parse(window.location.href, true);
    let credId;
    let uuid;
    let orgId;
    if (url?.query?.id) {
      credId = url.query.id;
    }
    if (url?.query?.uuid) {
      uuid = url.query.uuid;
    }
    if (url?.query?.no) {
      orgId = url.query.no;
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_CREDENTIAL_LIST,
          // variables: {
          //   input: {
          //     criteria: {schemaRef:id},
          //     offset: args?.offset ?? 0,
          //     size: args?.size ?? 10,
          //     filter:{uuid:"480e8a67-1089-455e-ba65-a99f4fac7693"}
          //   },
          // },

          variables: {
            filter: {
              uuid: uuid,
              schemaRef:credId,
              offset: args?.offset ?? 0,
              size: args?.size ?? 10,
            }
          },
          headers: {
            "org-id": orgId,
          },


          fetchPolicy: 'network-only',
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatIssuedCredentialTable(
            res?.data?.getSelectedCredPerSchemaPortfolioPublic?.data
          ); 

          return {
            ...config,
            ultCredentials: _rowData,
            isEmpty: res?.data?.getMySelectedCredPerSchemaPortfolio?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getMySelectedCredPerSchemaPortfolio?.currentPage,
            pageSize: res?.data?.getMySelectedCredPerSchemaPortfolio?.pageSize,
            totalCount: res?.data?.getMySelectedCredPerSchemaPortfolio?.totalCount,
            totalPages: res?.data?.getMySelectedCredPerSchemaPortfolio?.totalPages,
            // selectedData: _selectedData
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }

  private formatSelectedData(tabData : any){
    const ids= tabData.map((item) => item.credentials.map((cred) => 
      {
        return {id:cred.id}
      }
      ) ).flat()
    console.log("ddss",ids)
    return ids
  //   const ids= tabData.map((item) => item.credentials.map((cred) => {return cred.id
  //   }

  //   ) )
  // console.log("ddss",ids)
  // return ids
  }

  
  private formatIssuedCredentialTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          id: item?.id,
          name: item?.to,
          // image:item?.image,
          credential: item?.name,
          email: item?.email,
          dateCreated: item?.issuanceDate,
          issuer: item?.issuer,
          description: item?.description,
        };
      });
      console.log("_reds",_rowData)
    return _rowData;
  }
  // return { ...(config || {}) };
}
